var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scroll-bar",
    [
      _c(
        "div",
        { staticClass: "sidebar-logo" },
        [
          _c("svg-icon", {
            staticClass: "sidebar-logo__icon",
            attrs: { "icon-class": "login-mall" }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.sidebar.opened,
                  expression: "sidebar.opened"
                }
              ],
              staticClass: "sidebar-logo__text"
            },
            [_vm._v("商城管理系统")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-menu",
        {
          attrs: {
            mode: "vertical",
            "show-timeout": 200,
            "default-active": _vm.$route.path,
            collapse: _vm.isCollapse,
            "background-color": "transparent",
            "text-color": "rgba(255, 255, 255, 0.7)",
            "active-text-color": "#ffffff"
          }
        },
        [_c("sidebar-item", { attrs: { routes: _vm.routes } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-276800be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-276800be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Sidebar/index.vue
// module id = null
// module chunks = 